module.exports = __webpack_public_path__ + "img/portfolio-sidebar-act.10e8155c.svg";